"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgThumbsDownOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M30 4H20v2H6.51l-.23.14a11.69 11.69 0 00-5 7.06 14.86 14.86 0 00.52 8.18l.3.62h7.57l-.51 4.3a3.74 3.74 0 00.57 2.84A4.93 4.93 0 0013.79 31h2.14v-.95a11.57 11.57 0 011.86-5.39A16.69 16.69 0 0121.3 21H30zM16.19 23.52A13.6 13.6 0 0014.08 29h-.29a2.94 2.94 0 01-2.42-1c-.18-.26-.33-.48-.22-1.47l.77-6.53H3.48a13.37 13.37 0 01-.22-6.38A9.81 9.81 0 017.1 8H20v11.5a18.32 18.32 0 00-3.81 4.02zM28 19h-6V6h6z" })));
}
exports.default = SvgThumbsDownOutline;
//# sourceMappingURL=ThumbsDownOutline.js.map